import React, { useRef, useState } from 'react';

//-----------------------------------------------------------------------------------------
// Type Definitions:
//-----------------------------------------------------------------------------------------

interface HorizontalScrollProps {
	children: React.ReactNode;
	maxRowLength?: number;
}

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

const ViewContentRows: React.FC<HorizontalScrollProps> = ({ children, maxRowLength = 8 }) => {

	// state.

	const scrollRef = useRef<HTMLDivElement>(null);
	const [isDragging, setIsDragging] = useState(false);
	const [startX, setStartX] = useState(0);
	const [scrollLeft, setScrollLeft] = useState(0);

	// handlers.

	// begin drag.
	const handleMouseDown = (e: React.MouseEvent) => {
		if (!scrollRef.current) return;
		setIsDragging(true);
		setStartX(e.pageX - scrollRef.current.offsetLeft);
		setScrollLeft(scrollRef.current.scrollLeft);
	};

	// end drag.
	const handleMouseLeave = () => setIsDragging(false);
	const handleMouseUp = () => setIsDragging(false);

	// track drag.
	const handleMouseMove = (e: React.MouseEvent) => {
		if (!isDragging || !scrollRef.current) return;
		e.preventDefault();
		const x = e.pageX - scrollRef.current.offsetLeft;
		const walk = (x - startX) * 1.2; // scroll speed multiplier
		scrollRef.current.scrollLeft = scrollLeft - walk;
	};

	//return the HTML.
	return (
		<div
			ref={scrollRef}
			className="view-content-rows"
			onMouseDown={handleMouseDown}
			onMouseLeave={handleMouseLeave}
			onMouseUp={handleMouseUp}
			onMouseMove={handleMouseMove}
			style={{ userSelect: 'none', gridTemplateColumns: `repeat(${maxRowLength}, 1fr)` }}
		>
			{children}
		</div>
	);
};

export default ViewContentRows;